import MainRoutes from 'src/app/main/main-routing'
import CustomerSupportRoutes from 'src/app/dashboard/customerSupport/customer-support-routing'

export default [
    MainRoutes,
    CustomerSupportRoutes
]